import { render } from "./lhbdDetail.vue?vue&type=template&id=f61cc92e&scoped=true&ts=true"
import script from "./lhbdDetail.vue?vue&type=script&lang=ts"
export * from "./lhbdDetail.vue?vue&type=script&lang=ts"

import "./lhbdDetail.vue?vue&type=style&index=0&id=f61cc92e&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f61cc92e"]])

export default __exports__